module.exports = __webpack_public_path__ + "img/cirLight_1_1.9dc6764e.png";